import IUserApplicationsFilter from "interfaces/IUserApplicationsFilter";
import { GlobalState } from "little-state-machine";

export const updateUserApplicationsFilter = (state: GlobalState, userApplicationsFilter: IUserApplicationsFilter) => ({
  ...state,
  userApplicationsFilter
});
